import PropTypes from 'prop-types';
import RecipeFilter from './RecipeFilter';
import RecipeFiltersMobile from './RecipeFiltersMobile';

function SelectedFilter({ name, onUnselectButtonClick }) {
	return (
		<div className="selected-filter" key={name}>
			<span className="selected-filter-name">{name}</span>
			<button
				type="button"
				className="selected-filter-unselect"
				onClick={onUnselectButtonClick}
			>
				<span className="visually-hidden">unselect</span>
			</button>
		</div>
	);
}

SelectedFilter.propTypes = {
	name: PropTypes.string.isRequired,
	onUnselectButtonClick: PropTypes.func.isRequired,
};

function RecipeFiltersDesktop({
	filtersData, filterItems, filters, setFilters,
}) {
	return (
		<div className="recipe-filters-desktop">
			{Object.keys(filtersData).map((filter) => (
				<RecipeFilter
					title={filtersData[filter].title}
					name={filtersData[filter].name}
					items={filterItems[filter].nodes}
					key={filtersData[filter].title}
					filters={filters}
					setFilters={setFilters}
				/>
			))}
		</div>
	);
}

RecipeFiltersDesktop.propTypes = {
	filtersData: PropTypes.object.isRequired,
	filterItems: PropTypes.object.isRequired,
	filters: PropTypes.array.isRequired,
	setFilters: PropTypes.func.isRequired,
};

export default function RecipeFilters({
	filterItems, filters = [], setFilters, filtersData,
}) {
	// Go through filters and find item to remove
	const unselectFilter = (item) => {
		const filtersAfterRemoval = filters.filter(
			(current) => item.id !== current.id,
		);

		setFilters([...filtersAfterRemoval]);
	};

	const clearAll = () => {
		setFilters([]);
	};

	const filtersList = [];
	if (filters) {
		filters.forEach((filter) => {
			filtersList.push(filter.slug);
		});
	}

	// Adobe analytics data
	const adobeAnalyticsData = {
		searchFilters: filtersList,
	};

	return (
		<div className="recipe-filters">
			<RecipeFiltersDesktop
				filtersData={filtersData}
				filterItems={filterItems}
				filters={filters}
				setFilters={setFilters}
			/>
			<RecipeFiltersMobile
				filtersData={filtersData}
				filterItems={filterItems}
				filters={filters}
				setFilters={setFilters}
			/>
			{filters.length ? (
				<div className="selected-filters-section" data-search-filters={JSON.stringify(adobeAnalyticsData, null, 2)}>
					<div className="selected-filters">
						<>
							{filters.map((item) => (
								<SelectedFilter
									key={item.name}
									name={item.name}
									onUnselectButtonClick={() => unselectFilter(item)}
								/>
							))}
						</>
					</div>
					<button
						type="button"
						className="selected-filters-clear"
						onClick={() => { clearAll(); }}
					>
						Clear all
					</button>
				</div>
			) : (
				<div className="recipes-header-separator" aria-hidden="true">&nbsp;</div>
			)}
		</div>
	);
}

RecipeFilters.propTypes = {
	filtersData: PropTypes.object.isRequired,
	filterItems: PropTypes.object.isRequired,
	filters: PropTypes.array,
	setFilters: PropTypes.func.isRequired,
};
